// this is an autogenerated file from App/Account/PatientNotifications/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_PatientNotifications_Content($patient_id: uuid!) {
  vaxiom_patients(where: { _id: { _eq: $patient_id } }) {
    _id
    id
    person {
      id
      _id
      first_name
      last_name
    }
  }
}

`